import React from 'react';
import { useStyles } from './VideoGallery.styles';

const VideoGallery = () => {
  const classes = useStyles();
  return <div>VideoGallery</div>;
};

export default VideoGallery;
